<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
  
  export default {
    components: {
      
    }
  }
</script>

<style lang="scss">
html,body {
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #edf5fb;
  height: 100%;
}
*{
  margin:0;
  padding: 0; 
}




</style>
